import { render, staticRenderFns } from "./AsmtPrintQuestion.vue?vue&type=template&id=68b71024"
import script from "./AsmtPrintQuestion.vue?vue&type=script&lang=ts"
export * from "./AsmtPrintQuestion.vue?vue&type=script&lang=ts"
import style0 from "./AsmtPrintQuestion.vue?vue&type=style&index=0&id=68b71024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports